import { PaymentData, ApplePayConfiguration } from '@adyen/adyen-web';

import { AppchargeErrorType, EPaymentProvider, PaymentMethod } from '../../../../../../contracts';

export enum AdyenCheckoutErrorTypes {
  NETWORK_ERROR = 'NETWORK_ERROR',
  CANCEL = 'CANCEL',
  IMPLEMENTATION_ERROR = 'IMPLEMENTATION_ERROR',
  API_ERROR = 'API_ERROR',
  ERROR = 'ERROR',
  SCRIPT_ERROR = 'SCRIPT_ERROR',
  SDK_ERROR = 'SDK_ERROR',
}

// CANCEL is intentionally omitted: it is handled separately as a silent dismiss
// (see ACDEV-24170 acceptance criteria).
const ADYEN_SDK_ERROR_TO_APPCHARGE_ERROR: Partial<
  Record<AdyenCheckoutErrorTypes, AppchargeErrorType>
> = {
  [AdyenCheckoutErrorTypes.NETWORK_ERROR]: AppchargeErrorType.CONNECTION,
  [AdyenCheckoutErrorTypes.IMPLEMENTATION_ERROR]: AppchargeErrorType.GENERIC,
  [AdyenCheckoutErrorTypes.API_ERROR]: AppchargeErrorType.GENERIC,
  [AdyenCheckoutErrorTypes.ERROR]: AppchargeErrorType.GENERIC,
  [AdyenCheckoutErrorTypes.SCRIPT_ERROR]: AppchargeErrorType.GENERIC,
  [AdyenCheckoutErrorTypes.SDK_ERROR]: AppchargeErrorType.GENERIC,
};

export function mapAdyenSdkErrorToAppchargeError(
  sdkErrorName: string | undefined,
): AppchargeErrorType {
  if (!sdkErrorName) return AppchargeErrorType.GENERIC;
  return (
    ADYEN_SDK_ERROR_TO_APPCHARGE_ERROR[sdkErrorName as AdyenCheckoutErrorTypes] ??
    AppchargeErrorType.GENERIC
  );
}

export const APPLE_PAY_CONFIG: ApplePayConfiguration = {
  isExpress: true,
  showPayButton: true,
  requiredBillingContactFields: ['email'],
  requiredShippingContactFields: ['email'],
  domainName: getTopLevelDomain(),
};

export interface ApplePayPaymentDetailsRef {
  email: string;
  paymentMethodDetails: ApplePayJS.ApplePayPaymentMethod;
}

export function createAdyenApplePayFinalizeRequestBody(
  AdyenPaymentMethod: PaymentData,
  applePaymentDetails: ApplePayPaymentDetailsRef,
  ACPaymentMethod: PaymentMethod,
): any {
  return {
    paymentProvider: EPaymentProvider.adyen,
    receipt_email: applePaymentDetails.email,
    paymentMethodDisplayName: ACPaymentMethod?.paymentMethodDisplayName!,
    paymentMethodId: ACPaymentMethod?.id!,
    params: {
      paymentMethod: AdyenPaymentMethod.paymentMethod,
      paymentMethodDetails: applePaymentDetails.paymentMethodDetails,
    },
  };
}

function getTopLevelDomain(): string {
  try {
    const topLevelUrl =
      window.location !== window.parent.location ? document.referrer : document.location.href;
    if (!topLevelUrl) {
      return new URL(document.location.href).hostname;
    }
    return new URL(topLevelUrl).hostname;
  } catch {
    return new URL(document.location.href).hostname;
  }
}
